import { ColumnDescription } from "react-bootstrap-table-next";
import { BuscarCategoriasVendaUauController } from "../../../../../Controllers/Geral/InformacoesVenda/InformacoesVendaControllers";
import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import { IInformacoesErp } from "../../../../../Interfaces/Geral/InformacoesVenda/InformacoesVendaInterfaces";
import Table from "../../../../Table";
import LeiaMais from "../../../../Utils/LeiaMais";
import OrSpinner from "../../../../Utils/OrSpinner";

interface IInformacoesErpProps {
    idContaProduto: number;
}

export default function InformacoesErp(props: IInformacoesErpProps) {
    const { value: informacoesErp, loading: informacoesErpLoading } =
        useAsyncEffect(() =>
            BuscarCategoriasVendaUauController(props.idContaProduto)
        );

    return (
        <OrSpinner
            loading={informacoesErpLoading}
            loadingSize="lg"
            spinner="capys"
        >
            <div className="mt-5">
                {informacoesErp ? (
                    <Table
                        columns={tableviewColumns}
                        data={informacoesErp}
                        keyField="Comentario"
                        loading={informacoesErpLoading}
                        noHover
                        bordered={false}
                        defaultStyle={{
                            align: "center",
                            classes: "p-2",
                        }}
                        striped={true}
                        rowClasses={"rowClasses"}
                    />
                ) : (
                    <div className="text-black-50 text-center">
                        Nenhuma Informação Encontrada
                    </div>
                )}
            </div>
        </OrSpinner>
    );
}

const tableviewColumns: Array<ColumnDescription<IInformacoesErp>> = [
    {
        dataField: "NumeroComentario",
        text: "Número do Comentário",
    },
    {
        dataField: "Comentario",
        text: "Comentario",
        formatter: (c) => <LeiaMais charLimit={40}>{c}</LeiaMais>,
    },
    {
        dataField: "DataComentario",
        text: "Data do Comentario",
        formatter: (c) => (c ? new Date(c).toLocaleString() : "-"),
    },
    {
        dataField: "Categoria",
        text: "Categoria",
    },
];
